import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "download-pop" }
const _hoisted_2 = { class: "download-title" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "method-label" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "method-label" }
const _hoisted_7 = { class: "action-row" }

import { ref } from 'vue';
import pwaImage from '@/assets/download/pwa-option.png';
import apkImage from '@/assets/download/apk-option.png';


export default /*@__PURE__*/_defineComponent({
  __name: 'DownloadPlatformSelectionPopup',
  emits: ["select"],
  setup(__props, { expose: __expose, emit: __emit }) {

const emit = __emit;

const visible = ref(false);
const pwaAvailable = ref(false);
const selectedMethod = ref<'pwa' | 'apk'>('pwa');

const open = (pwaSupported: boolean) => {
    pwaAvailable.value = pwaSupported;
    selectedMethod.value = pwaSupported ? 'pwa' : 'apk';
    visible.value = true;
};

const close = () => {
    visible.value = false;
};

const selectPwa = () => {
    if (pwaAvailable.value) {
        selectedMethod.value = 'pwa';
    }
};

const onConfirm = () => {
    const method = selectedMethod.value === 'pwa' && !pwaAvailable.value
        ? 'apk'
        : selectedMethod.value;
    visible.value = false;
    emit('select', method);
};

__expose({ open });

return (_ctx: any,_cache: any) => {
  const _component_van_radio = _resolveComponent("van-radio")!
  const _component_van_radio_group = _resolveComponent("van-radio-group")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createBlock(_component_van_popup, {
    show: visible.value,
    "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((visible).value = $event)),
    round: "",
    style: {"width":"85%","background":"transparent"},
    onClickOverlay: close
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.$t('downloadPlatform.title')), 1),
        _createVNode(_component_van_radio_group, {
          modelValue: selectedMethod.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedMethod).value = $event)),
          class: "method-options"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(["method-card", {
                        selected: selectedMethod.value === 'pwa' && pwaAvailable.value,
                        'method-card--disabled': !pwaAvailable.value
                    }]),
              onClick: selectPwa
            }, [
              _createVNode(_component_van_radio, {
                name: "pwa",
                "checked-color": "#01875f",
                class: "method-radio",
                disabled: !pwaAvailable.value
              }, null, 8, ["disabled"]),
              _createElementVNode("img", {
                src: _unref(pwaImage),
                alt: "PWA",
                class: _normalizeClass(["method-image", { 'method-image--muted': !pwaAvailable.value }])
              }, null, 10, _hoisted_3),
              _createElementVNode("span", _hoisted_4, _toDisplayString(pwaAvailable.value ? _ctx.$t('downloadPlatform.pwa') : _ctx.$t('downloadPlatform.pwaNotSupported')), 1)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["method-card", { selected: selectedMethod.value === 'apk' }]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (selectedMethod.value = 'apk'))
            }, [
              _createVNode(_component_van_radio, {
                name: "apk",
                "checked-color": "#01875f",
                class: "method-radio"
              }),
              _createElementVNode("img", {
                src: _unref(apkImage),
                alt: "APK",
                class: "method-image"
              }, null, 8, _hoisted_5),
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('downloadPlatform.apk')), 1)
            ], 2)
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_van_button, {
            class: "confirm-btn",
            block: "",
            onClick: onConfirm
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.ok')), 1)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})